import HeadlinesFooter from "@components/common/Footer/HeadlinesFooter";
import { getLayout } from "@components/common/Layout";
import StudentNavbar from "@components/common/Navbar/StudentNavbar";
import OrdersList from "@components/student/wallet/OrdersList";
import WalletDadcoin from "@components/student/wallet/WalletDadcoin";
import WalletToman from "@components/student/wallet/WalletToman";
import gate from "@gate/index";
import { OrderStatus } from "@interfaces/basket";
import { loginUser, setProfile } from "@store/reducers/auth";
import { Button } from "components";
import { GetServerSideProps } from "next";
import { useRouter } from "next/router";
import React, { useState } from "react";
import { dehydrate, QueryClient, useQuery } from "react-query";
import { useDispatch } from "react-redux";
import {
  commafy,
  convertMiladiToJalali,
  convertNumberToPriceFormat,
} from "src/utils";

import styles from "./style.module.css";

export const getServerSideProps: GetServerSideProps = async (ctx) => {
  const queryClient = new QueryClient();
  const { query } = ctx;
  const token = query.token || "";

  try {
    if (token && typeof token === "string")
      await queryClient.fetchQuery(`app-login`, () =>
        gate.loginFromApp({ token })
      );
  } catch (error: any) {
    console.log(error);
  }

  return {
    props: {
      dehydratedState: dehydrate(queryClient),
    },
  };
};

const Wallet = () => {
  const { push } = useRouter();
  const [tab, setTab] = useState(1);
  const dispatch = useDispatch();
  const router = useRouter();
  const { token } = router.query;
  const userData = useQuery(
    "app-login",
    () => gate.loginFromApp({ token: typeof token === "string" ? token : "" }),
    {
      select: (data: any) => data,
    }
  );

  if (userData.data) {
    dispatch(loginUser({ token: { ...userData.data } }));
    dispatch(setProfile({ token: { ...userData.data } }));
  }
  const { data: dataWallet, isLoading: isLoadingWallet } = useQuery(
    "wallet",
    () => gate.wallet(),
    {
      select: ({ data }: any) => data.output,
    }
  );
  const {
    data: creditBalanceData,
    refetch,
    isLoading,
  } = useQuery(`credit-balance`, () => gate.getCreditBalance(), {
    select: ({ data }: any) => data,
  });

  const handleClickItem = (status: number | string, id: number | string) => {
    if (status == OrderStatus.Inprogress) {
      push(`/basket/${id}/installment`);
    } else {
      push(`/basket/${id}`);
    }
  };
  const renderTabContent = () => {
    switch (tab) {
      case 1: {
        return <OrdersList data={dataWallet} isLoading={isLoadingWallet} />;
      }
      case 2: {
        return (
          <WalletToman
            availableBalance={getAvailableBalance(creditBalanceData, "TOMAN")}
          />
        );
      }
      case 3: {
        return (
          <WalletDadcoin
            availableBalance={getAvailableBalance(creditBalanceData, "DADCOIN")}
          />
        );
      }
      default: {
        return <OrdersList data={dataWallet} isLoading={isLoadingWallet} />;
      }
    }
  };
  const getAvailableBalance = (data: any, type: string): number => {
    if (data) {
      const item = data?.balances.find((item: any) => item.coin === type);
      if (item) {
        return item.availableBalance;
      }
      return 0;
    }
    return 0;
  };

  return (
    <>
      <div
        className="h-full bg-[#FAFAFC] py-4 md:py-8 xl:pt-10 xl:pb-20"
        style={{ minHeight: "inherit" }}
      >
        <div className="mx-auto w-[81%] md:w-[84%] xl:w-[73.9%]">
          <div className="mb-5 grid grid-cols-1 gap-x-5 gap-y-2 text-xs md:grid-cols-[_300px,_1fr] md:gap-y-0 2xl:grid-cols-[_380px,_1fr] 2xl:text-base">
            <div className="flex rounded bg-white p-2 text-[#4A4A4A] shadow-sm md:p-5">
              <div className="w-full">
                <div className="grid grid-cols-12 gap-y-[10px]">
                  <div className="col-span-6"> اعتبار کیف پول:</div>
                  {/*<div className="col-span-6"> اعتبار کیف پول تومانی:</div>*/}
                  <div className="col-span-6 flex text-left text-sm font-bold text-[#183BA7] 2xl:text-lg">
                    <span className="ml-2 text-sm text-[#4A4A4A80]">
                      (تومان)
                    </span>
                    <span className="flex-1">
                      {convertNumberToPriceFormat(
                        getAvailableBalance(creditBalanceData, "TOMAN")
                      )}
                    </span>
                  </div>
                </div>
                <div className="mt-[3px] grid grid-cols-12 gap-y-[10px]">
                  <div className="col-span-6"> اعتبار کیف پول دادکوین:</div>
                  <div className="col-span-6 flex text-left text-sm font-bold text-[#183BA7] 2xl:text-lg">
                    <span className="ml-2 text-sm text-[#4A4A4A80]">
                      (دادکوین)
                    </span>
                    <span className="flex-1" style={{ direction: "ltr" }}>
                      {convertNumberToPriceFormat(
                        getAvailableBalance(creditBalanceData, "DADCOIN")
                      )}
                    </span>
                  </div>
                </div>
                <p className="mb-0 mt-[10px] text-xs">
                  هر دادکوین معادل یک تومان است.
                </p>
              </div>
            </div>
            <div className="rounded bg-white p-5 text-xs shadow-sm 2xl:text-base">
              <div className="grid grid-rows-2 gap-y-[20px]">
                {dataWallet?.installPayment?.id ? (
                  <>
                    <span className="2xl:text-sm 3xl:text-base">
                      آخرین پیش فاکتور
                    </span>
                    <span className="flex text-ellipsis whitespace-nowrap 2xl:hidden">
                      {dataWallet?.installPayment?.description}
                    </span>
                    <div className="flex-col items-center justify-between md:flex md:flex-row">
                      <span className="ml-2 hidden text-ellipsis whitespace-nowrap 2xl:flex 2xl:text-sm 3xl:text-base">
                        {dataWallet?.installPayment?.description}
                      </span>
                      <div className="grid-template-columns-max grid w-full grid-flow-col gap-x-5 2xl:text-sm 3xl:text-base">
                        <span className="text-[#34C38F]">
                          مبلغ{" "}
                          <span>
                            {commafy(dataWallet?.installPayment?.price)}
                          </span>{" "}
                          تومان
                        </span>
                        <span className="whitespace-nowrap text-[#F46A6A]">
                          مهلت پرداخت{" "}
                          <span>
                            {convertMiladiToJalali(
                              dataWallet?.installPayment?.validDate
                            )}
                          </span>
                        </span>
                      </div>
                      <Button
                        onClick={() =>
                          push(
                            `/basket/${dataWallet?.installPayment?.id}/installment?status=1`
                          )
                        }
                        CClassName="border w-full md:w-auto mt-4 md:mt-0 border-blue-550 whitespace-nowrap text-sm text-blue-550 rounded px-[10px] py-[5px]"
                      >
                        مشاهده و پرداخت
                      </Button>
                    </div>
                  </>
                ) : (
                  <>
                    <span className="font-medium text-[#4A4A4A]">
                      آخرین پیش فاکتور
                    </span>
                    <span className="text-[#555555]">
                      پیش فاکتوری برای دوره اقساطی به ثبت نرسیده است.
                    </span>
                  </>
                )}
              </div>
            </div>
          </div>
          <div>
            <div className={`md:shadow-sm ${styles.tabHeader}`}>
              <button
                onClick={() => setTab(1)}
                className={`${
                  tab === 1 ? styles.active : ""
                } text-xs md:text-base`}
              >
                سفارشات
              </button>
              <button
                onClick={() => setTab(2)}
                className={`${
                  tab === 2 ? styles.active : ""
                } text-xs md:text-base`}
              >
                کیف پول تومانی
              </button>
              <button
                onClick={() => setTab(3)}
                className={`${
                  tab === 3 ? styles.active : ""
                } text-xs md:text-base`}
              >
                کیف پول دادکوین
              </button>
            </div>
            <div className="w-full bg-white pt-5 md:shadow-sm">
              {renderTabContent()}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
Wallet.getLayout = (page: any) =>
  getLayout(page, {
    FooterComponent: <HeadlinesFooter />,
    HeaderComponent: <StudentNavbar />,
  });

export default Wallet;
